var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.reload)?_c('TransactionTemplate',{ref:"work-order-detail",attrs:{"getHeaderToolbar":_vm.getHeaderToolbar,"screenJson":_vm.getScreenJson,"headerScreenJson":_vm.getHeaderScreenJson,"setLoading":_vm.setLoading,"localDataGrid":false,"backButtonRoute":_vm.getBackButtonRoute(),"isLoaded":_vm.loaded,"paging":false,"tabs":{}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }